import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { HttpService } from '../../../http.service';

declare var $: any;

@Component({
  selector: 'app-giftcardissuance',
  templateUrl: './giftcardissuance.component.html',
  styleUrls: ['./giftcardissuance.component.css']
})
export class GiftcardissuanceComponent implements OnInit {
	giftcardissuanceForm: FormGroup;
	isSubmitted  =  false;
	checkOutSpin  =  0;
	cardErrorApiCall:any=  '';
	successmessage:any=  '';

	constructor(	private formBuilder: FormBuilder,private _http: HttpService) { }

	ngOnInit(): void {
		this.giftcardissuanceForm  =  this.formBuilder.group({
				card_number: ['', Validators.required],
				pin: ['', Validators.required],
				amount: ['', Validators.required],
				email: ['', Validators.required],
				first_name: [''],
				middleName: [''],
				lastName: [''],
				postal: [''],
				phone: [''],
			
				
			});
		this.loadCarddiv();
	
	}
	get formControls() { return this.giftcardissuanceForm.controls; }
	
	loadCarddiv(){
		$('#card_number_gift').validateCreditCard(function(result) {
		if(result.card_type){		
		if(result.card_type.name=='visa'){
			$('#card_number_gift').attr('maxlength','16');
		}  
		if(result.card_type.name=='mastercard'){
			$('#card_number_gift').attr('maxlength','16');
		}
		if(result.card_type.name=='amex'){
			$('#card_number_gift').attr('maxlength','15');
		}
		}
			  
		if(result.card_type == null)
		{
		$('#card_number_gift').removeClass();
		}
		else
		{
		$('#card_number_gift').addClass(result.card_type.name);
		}

		if(!result.valid)
		{
		$('#card_number_gift').removeClass("valid");
		}
		else
		{
		$('#card_number_gift').addClass("valid");
		}
			
		});	

  }
	checkOutProccess () {
		this.cardErrorApiCall='';
		this.isSubmitted = true;
		
		if(this.giftcardissuanceForm.invalid){
		  return;
		}
		this.checkOutSpin=1;
		const giftcardissuance = new FormData();
		giftcardissuance.append( 'card_number', this.giftcardissuanceForm.value.card_number );
		giftcardissuance.append( 'pin', this.giftcardissuanceForm.value.pin );
		giftcardissuance.append( 'amount', this.giftcardissuanceForm.value.amount );
		giftcardissuance.append( 'email', this.giftcardissuanceForm.value.email );
		giftcardissuance.append( 'first_name', this.giftcardissuanceForm.value.first_name );
		giftcardissuance.append( 'middleName', this.giftcardissuanceForm.value.middleName );
		giftcardissuance.append( 'lastName', this.giftcardissuanceForm.value.lastName );
		giftcardissuance.append( 'postal', this.giftcardissuanceForm.value.postal );
		giftcardissuance.append( 'phone', this.giftcardissuanceForm.value.phone );
		
		
		this._http.postRequest('giftcardissuance.php',giftcardissuance).subscribe((reponse : any)=>{
			this.checkOutSpin=0;
			if (reponse.standardHeader.status === 'E') {
				this.cardErrorApiCall = reponse.errorMessage.inDepthMessage;
			}
			if (reponse.standardHeader.status === 'A') {
				//this.cardErrorApiCall = reponse.errorMessage.inDepthMessage;
				this.successmessage = "Balance has been added into your gift card..!!"
				this.giftcardissuanceForm.reset();
				this.isSubmitted = false;
			}
		}) 
	  
	}
}
